import Chip from '@material-ui/core/Chip';
import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import React, { Component } from 'react';
import Button from '../Button';
import Input from '../Input';

interface IProps {
  id: string | number;
  target: 'event' | 'membership';
  onChange: any;
}

type ActiveType = 'button' | 'picker' | 'chip';

interface IInputEvent {
  target: {
    value: string;
  };
}

interface ICoupon {
  title: string;
  discountValue: string;
}

interface IState {
  active: ActiveType;
  coupon?: ICoupon;
  input: string;
  error: boolean;
}

class CouponPicker extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      active: 'button',
      error: false,
      input: ''
    };

    this.close = this.close.bind(this);
    this.setInput = this.setInput.bind(this);
    this.checkCoupon = this.checkCoupon.bind(this);
  }

  public toggle = (active: ActiveType) => async () => {
    this.setState({ active });

    this.props.onChange();
  };

  public async checkCoupon(): Promise<void> {
    const { coupon } = await this.props.onChange(this.state.input);

    if (coupon) {
      this.setState({ coupon, active: 'chip' });
    } else {
      this.setState({ error: true });
    }
  }

  public setInput(event: IInputEvent): void {
    this.setState({ input: event.target.value, error: false });
  }

  public close(): void {
    this.setState({ active: 'button', input: '' });
    this.props.onChange();
  }

  public render(): JSX.Element {
    const { active, coupon, error } = this.state;
    return (
      <div className="coupon-picker">
        <div className={`button ${active === 'button' ? 'active' : ''}`}>
          <Button color="primary" onClick={this.toggle('picker')} id="open-picker">
            I HAVE A COUPON
          </Button>
        </div>
        <div className={`picker ${active === 'picker' ? 'active' : ''}`}>
          <Input
            label="Coupon Code"
            id="coupon-code"
            type="text"
            value={this.state.input}
            onChange={this.setInput}
            hasError={error}
            errorMessage="Invalid coupon code"
          />

          <Fab
            color="primary"
            size="small"
            onClick={this.checkCoupon}
            aria-label="apply"
            id="check-button"
            disabled={!this.state.input}
          >
            <DoneIcon />
          </Fab>

          <IconButton color="primary" onClick={this.close} aria-label="cancel" id="close-button">
            <CloseIcon />
          </IconButton>
        </div>
        <div className={`chip ${active === 'chip' ? 'active' : ''}`}>
          <Chip
            label={coupon ? coupon.title : ''}
            onDelete={this.close}
            className="chip-item"
            color="primary"
            variant="outlined"
          />
          <div className="coupon-value">
            ${coupon ? Number(coupon.discountValue).toFixed(2) : 0}
          </div>
        </div>
      </div>
    );
  }
}

export { CouponPicker };
